module.exports = __webpack_public_path__ + "static/media/jdpower-rating-07.cdbd62e2.png";